import {
  CALENDAR_EVENTS_FETCH_START,
  CALENDAR_EVENTS_FETCH_FAIL,
  CALENDAR_EVENTS_FETCH_SUCCESS,
} from '../constants/actionTypes'

const initialState = {
  events: [],
  total: 0,
  count: 0,
  offset: 0,
  fetchEventsProgress: {
    loading: true,
    errors: null,
  },
}

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fecth Events
    case CALENDAR_EVENTS_FETCH_START: {
      return Object.assign({}, state, {
        fetchEventsProgress: {
          loading: true,
          error: null,
        },
      })
    }
    case CALENDAR_EVENTS_FETCH_FAIL: {
      return Object.assign({}, state, {
        fetchEventsProgress: {
          loading: false,
          error: action.error,
        },
      })
    }
    case CALENDAR_EVENTS_FETCH_SUCCESS: {
      const { total_count: total, size, offset, content } = action.value

      return Object.assign({}, state, {
        fetchEventsProgress: {
          loading: false,
          error: null,
        },
        events: content,
        total,
        count: size,
        offset,
      })
    }

    default:
      return state
  }
}

export default eventsReducer
export { initialState }
